import type { SchedulingWindowEvaluation, SchedulingWindowPeriod } from '../endpoints/fetchFirstOccurrence';

/**
 * Project a window evaluation's available periods into plain period objects — a
 * defensive copy; an absent evaluation yields `[]`.
 */
export const mapAvailablePeriods = (evaluation: SchedulingWindowEvaluation | undefined): ReadonlyArray<SchedulingWindowPeriod> =>
  (evaluation?.available_periods ?? []).map((period) => ({
    open: period.open,
    close: period.close,
  }));
